<template>
  <div class="receipt-header">
    <div class="receipt-header-text">
      <div class="receipt-header-text-border">
        <span class="receipt-header-text-border-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M32 12.8H12.8V32H0V12.8C0 5.73076 5.73076 0 12.8 0H32L32 12.8Z"
              :fill="primaryColor"
            />
          </svg>
        </span>
        <span class="receipt-header-text-border-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M32 12.8H12.8V32H0V12.8C0 5.73076 5.73076 0 12.8 0H32L32 12.8Z"
              :fill="primaryColor"
            />
          </svg>
        </span>
        <span class="receipt-header-text-border-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M32 12.8H12.8V32H0V12.8C0 5.73076 5.73076 0 12.8 0H32L32 12.8Z"
              :fill="primaryColor"
            />
          </svg>
        </span>
        <span class="receipt-header-text-border-item">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M32 12.8H12.8V32H0V12.8C0 5.73076 5.73076 0 12.8 0H32L32 12.8Z"
              :fill="primaryColor"
            />
          </svg>
        </span>
      </div>
      <h1>
        {{ $t("receipt.title") }}
      </h1>
      <div class="receipt-header-text-logo">
        <img
          src="@/assets/img/small-logo.png"
          alt="Tippie"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReceiptreceiptHeader",
  props: {
    primaryColor: {
      type: String,
      default: "#FF8A00",
    },
  },
};
</script>

<style scoped lang="scss">
.receipt-header {
  background: #f6f7f9;
  padding: 24px 32px 32px 32px;

  &-text {
    position: relative;

    h1::v-deep {
      span {
        color: #ff8a00;
      }
    }

    &-border {
      &-item {
        position: absolute;

        &:first-child {
          top: 0;
          left: 0;
        }

        &:nth-child(2) {
          top: 0;
          right: 0;
          transform: rotate(90deg);
        }

        &:nth-child(3) {
          bottom: 0;
          left: 0;
          transform: rotate(-90deg);
        }

        &:last-child {
          bottom: 0;
          right: 0;
          transform: rotate(180deg);
        }
      }
    }

    h1 {
      color: #000000;
      font-family: "Raleway Bold", serif;
      font-size: 32px;
      text-align: center;
      line-height: 44px;
      margin: 0;
      padding: 40px 16px 20px 16px;
    }

    &-logo {
      img {
        display: flex;
        margin: 0 auto;
      }
    }
  }
}
</style>
